<template>
  <div class="big">
    <div class="page_title flex_between">
      <span>
        <span>问诊单详情</span>
      </span>
      <el-button type="primary" style="width: 92px" size="medium" @click="back"
        >返回</el-button
      >
    </div>
    <div style="padding: 20px">
      <div class="container">
        <div class="flex">
          <div class="info" style="margin-right: 20px">
            <div style="display: flex">
              <div class="infoitem">
                <span class="infotitle">医生姓名：</span>
                <span
                  @click="showDocMsg(doctor_info.doctor_id)"
                  style="cursor: pointer"
                  >{{ doctor_info.doctor_name }}</span
                >
              </div>
              <div class="infoitem">
                <span class="infotitle">性别：</span>
                <span>{{ doctor_info.sex == 1 ? "男" : "女" }}</span>
              </div>
              <div class="infoitem">
                <span class="infotitle">年龄：</span>
                <span>{{ doctor_info.age }}</span>
              </div>
            </div>
            <div class="infoitem" style="margin: 15px 0">
              <span class="infotitle">手机号：</span>
              <span>{{ doctor_info.phone }}</span>
            </div>
            <div class="flex">
              <div class="infoitem">
                <span class="infotitle">科室：</span>
                <span>{{ doctor_info.department_name }}</span>
              </div>
              <div class="infoitem">
                <span class="infotitle">职称：</span>
                <span>{{ doctor_info.title }}</span>
              </div>
            </div>
            <div class="infoitem" style="margin-top: 15px">
              <span class="infotitle">医院名称：</span>
              <span>{{ doctor_info.hospital }}</span>
            </div>
          </div>
          <div class="info">
            <div class="flex">
              <div class="infoitem">
                <span class="infotitle">患者姓名：</span>
                <span>{{ patient_info.real_name }}</span>
              </div>
              <div class="infoitem">
                <span class="infotitle">性别：</span>
                <span v-if="patient_info.sex == 1">男</span>
                <span v-if="patient_info.sex == 2">女</span>
                <span v-if="patient_info.sex == 0">未知</span>
              </div>
              <div class="infoitem">
                <span class="infotitle">年龄：</span>
                <span>{{ patient_info.age }}</span>
              </div>
            </div>
            <div class="flex" style="margin: 15px 0">
              <div class="infoitem">
                <span class="infotitle">手机号：</span>
                <span>{{ patient_info.phone }}</span>
              </div>
              <div class="infoitem">
                <span class="infotitle">用户昵称：</span>
                <span>{{ patient_info.nick_name }}</span>
              </div>
            </div>
            <div class="infoitem">
              <span class="infotitle">既往病史：</span>
              <span>{{ patient_info.history_name }}</span>
            </div>
            <div class="infoitem" style="margin-top: 15px">
              <span class="infotitle">过敏历史：</span>
              <span>{{ patient_info.allergen_name }}</span>
            </div>
          </div>
        </div>

        <div style="border: solid 1px #c9cbd6; margin-top: 20px">
          <el-table
            v-loading="tableLoading"
            :data="tableData"
            tooltip-effect="dark"
            style="width: 100%; min-width: 1000px"
            :header-cell-style="{ background: '#F5F5F5' }"
          >
            <el-table-column
              v-for="item in tableHeader"
              :key="item.prop"
              :prop="item.prop"
              :label="item.label"
              :width="item.width"
              :fixed="item.fixed"
            >
              <template slot-scope="scope">
                <div v-if="item.prop == 'send_time'">
                  {{ scope.row[item.prop] | dateFormat }}
                </div>

                <div v-else-if="item.prop == 'is_inquiry'">
                  {{ scope.row[item.prop] ? "已填写" : "未填写" }}
                </div>

                <div v-else-if="item.prop == 'lose_status'">
                  {{ scope.row[item.prop] ? "已失效" : "未失效" }}
                </div>

                <div v-else>
                  {{
                    JSON.stringify(scope.row[item.prop]) === "null"
                      ? ""
                      : scope.row[item.prop]
                  }}
                </div>
              </template>
            </el-table-column>

            <el-table-column
              label="操作"
              width="160"
              align="center"
              fixed="right"
            >
              <template slot-scope="scope">
                <div v-if="!scope.row.is_inquiry && !scope.row.lose_status">
                  <el-button
                    type="text"
                    size="medium"
                    :disabled="
                      module_id_array[0]
                        ? !module_id_array.includes('1982')
                        : false
                    "
                    @click="pushAgain(scope.row)"
                    >重新推送</el-button
                  >
                  <el-button
                    type="text"
                    size="medium"
                    :disabled="
                      module_id_array[0]
                        ? !module_id_array.includes('1985')
                        : false
                    "
                    @click="submitInfo(scope.row)"
                    >填写随访单</el-button
                  >
                </div>
                <el-button
                  v-else
                  type="text"
                  size="medium"
                  :disabled="
                    module_id_array[0]
                      ? !module_id_array.includes('1984')
                      : false
                  "
                  @click="lookInfo(scope.row)"
                  >查看</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import dayjs from "dayjs";
import message from "@/api/message.js";
export default {
  data() {
    return {
      tableHeader: [
        {
          label: "推送时间",
          prop: "send_time",
          width: "auto",
          align: "center",
          fixed: "left",
        },
        {
          label: "随访单模板名称",
          prop: "inquiry_sheet_name",
          width: "auto",
          align: "center",
          fixed: false,
        },
        {
          label: "随访单填写",
          prop: "is_inquiry",
          width: "auto",
          align: "center",
          fixed: false,
        },
        {
          label: "填写人",
          prop: "edit_name",
          width: "auto",
          align: "center",
          fixed: false,
        },
        {
          label: "状态",
          prop: "lose_status",
          width: "auto",
          align: "center",
          fixed: false,
        },
      ],
      tableData: [],
      patient_info: {},
      doctor_info: {},
    };
  },
  filters: {
    dateFormat(val) {
      return !val ? "" : dayjs.unix(val).format("YYYY-MM-DD HH:mm");
    },
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    },
  },

  created() {
    this.getDetail();
  },
  activated() {
    this.getDetail();
  },
  methods: {
    //获取详情
    getDetail() {
      this.tableLoading = true;
      let data = {
        business_id: this.$route.query.business_id,
        doctor_id: this.$route.query.doctor_id,
        patient_id: this.$route.query.patient_id,
      };
      message.inquiryDelailLists(data).then((res) => {
        if (res.code == 0) {
          this.patient_info = res.data.patient_info;
          this.doctor_info = res.data.doctor_info;
          this.tableData = res.data.list;
          this.tableLoading = false;
        }
      });
    },
    // 重新推送
    pushAgain(row) {
      this.$confirm("确定重新推送吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(() => {
          const loading = this.$loading();
          message
            .pushInquiryAgain({ consult_inquiry_id: row.consult_inquiry_id })
            .then((res) => {
              if (res.code == 0) {
                this.$message.success("推送成功");
                this.getDetail();
              }
            })
            .finally(() => {
              loading.close();
            });
        })
        .catch(() => {});
    },
    //填写随访单
    submitInfo(row) {
      let { consult_inquiry_id, is_inquiry } = row;
      this.$router.push({
        path: "/home/message/inquiryDetail",
        query: { consult_inquiry_id, is_inquiry, is_look: 0 },
      });
    },
    // 查看
    lookInfo(row) {
      let { consult_inquiry_id, is_inquiry } = row;
      this.$router.push({
        path: "/home/message/inquiryDetail",
        query: { consult_inquiry_id, is_inquiry, is_look: 1 },
      });
    },
    //返回
    back() {
      history.back();
    },
  },
};
</script>
<style lang="scss" scoped>
.container {
  padding: 20px;
  box-sizing: border-box;
  background: #fff;
  min-height: calc(100vh - 140px);
}
.info {
  background-color: #f9f8ee;
  border: solid 1px #dad8ca;
  padding: 10px 0 10px 20px;
  text-align: left;
  .infoitem {
    margin-right: 30px;
    .infotitle {
      display: inline-block;
      margin-right: 10px;
    }
  }
}
</style>
